export default __webpack_public_path__ + "static/media/3.d80ac500.png";